"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_rxk_1 = require("react-rxk");
const text_1 = require("./text");
const keautils_1 = require("keautils");
const formatScales = {
    "int": { format: x => "" + x },
    "int-2-digit": { format: x => keautils_1.formatNumber(x, 2) },
    "percentage": { format: x => keautils_1.formatNumber(x, 1, 2, true, "%"), scale: 100 },
    "currency": { format: x => keautils_1.formatNumber(x, 1, 2, true, "$") },
    "decimal": { format: x => keautils_1.formatNumber(x, 1, 2, true) }
};
function toTextValue(value, format, scale) {
    if (value == null)
        return "";
    return format((value * scale));
}
function fromTextValue(value, scale) {
    if (value == null || value == "")
        return null;
    const parsed = parseFloat(value);
    return parsed / scale;
}
class NumberNoRx extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onFocus = () => {
            this.setState({ focused: true });
        };
        this.onBlur = () => {
            this.setState({ focused: false });
        };
        this.formatScale = () => this.props.format == null ? formatScales["int"] :
            typeof this.props.format == "string" ? formatScales[this.props.format || "int"] :
                this.props.format;
        this.onChange = (x) => {
            if (this.props.onChange)
                this.props.onChange(fromTextValue(x, this.formatScale().scale || 1));
        };
        this.state = { focused: false };
    }
    render() {
        const value = this.props.value;
        const formatScale = this.formatScale();
        const format = this.state.focused ? x => "" + x : formatScale.format;
        const textValue = toTextValue(value, format, formatScale.scale || 1);
        return React.createElement(text_1.TextInputNoRx, Object.assign({}, this.props, { value: textValue, onChange: this.onChange, onFocus: this.onFocus, onBlur: this.onBlur, selectAllOnFocus: true }));
    }
}
exports.Number = react_rxk_1.componentToRx(NumberNoRx, undefined, undefined, {
    loading: { loading: true },
    error: {
        ignore: {
            observable: true,
            promise: true
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/fields/number.js
// module id = 2211
// module chunks = 0